import type { Command } from '../../menu/types';
import { ShowDayTrackedStatsPopup } from './day-tracked-stats/ShowDayTrackedStatsPopup';
import type { GridReactCommandRegistry, GridReactCommandRenderer } from './types';

const gridReactCommandRegistry: GridReactCommandRegistry = new Map([
  ['showDayTrackedStatsPopup', (props) => <ShowDayTrackedStatsPopup {...props} />],
]);

const REACT_COMMAND_ALIASES = new Set(['reactcommand', 'zreactcommand']);

export const isGridReactCommand = (command: Command): boolean =>
  REACT_COMMAND_ALIASES.has(command.alias.toLowerCase());

export const resolveGridReactCommand = (
  renderingClass: string | null | undefined,
  registry: GridReactCommandRegistry = gridReactCommandRegistry
): GridReactCommandRenderer | null => {
  if (!renderingClass) return null;
  return registry.get(renderingClass) ?? null;
};

export const findFirstSupportedGridReactCommand = (
  commands: Command[] | undefined,
  registry: GridReactCommandRegistry = gridReactCommandRegistry
): Command | null => {
  if (!commands) return null;

  return (
    commands.find(
      (command) =>
        isGridReactCommand(command) &&
        resolveGridReactCommand(command.renderingClass, registry) !== null
    ) ?? null
  );
};
